
import SEOHead from '../../components/seo/SEOHead';
import HonorsHeroSection from './components/HonorsHeroSection';
import AwardsTimelineSection from './components/AwardsTimelineSection';
import CertificationsSection from './components/CertificationsSection';
import FutureVisionSection from './components/FutureVisionSection';

export default function Honors() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "荣誉资质",
    "description": "顺年陈获得的各项荣誉奖项和权威认证，见证我们在年份茶行业的专业地位和卓越成就。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/honors`,
    "mainEntity": {
      "@type": "Organization",
      "name": "顺年陈",
      "award": [
        "中国茶叶行业十大品牌",
        "年份茶标准制定单位",
        "ISO9001质量管理体系认证"
      ]
    }
  };

  return (
    <div className="min-h-screen">
      <SEOHead
        title="荣誉资质 - 顺年陈获奖与认证"
        description="顺年陈获得的各项荣誉奖项和权威认证，见证我们在年份茶行业的专业地位和卓越成就。包括行业大奖、质量认证等。"
        keywords="荣誉资质,获奖认证,茶叶行业奖项,质量认证,顺年陈荣誉,行业地位"
        canonical="/honors"
        structuredData={structuredData}
      />
      <HonorsHeroSection />
      <AwardsTimelineSection />
      <CertificationsSection />
      <FutureVisionSection />
    </div>
  );
}
